import Axios from 'axios';
import { Config } from '../apiRoutes';
import { authHeaders } from '../headers';

import {
  LOGIN_CODES_INDEX_REQUESTED,
  LOGIN_CODES_INDEX_SUCCESS,
  LOGIN_CODES_INDEX_FAILURE,
  LOGIN_CODE_CREATE_REQUESTED,
  LOGIN_CODE_CREATE_SUCCESS,
  LOGIN_CODE_CREATE_FAILURE,
  LOGIN_CODE_UPDATE_REQUESTED,
  LOGIN_CODE_UPDATE_SUCCESS,
  LOGIN_CODE_UPDATE_FAILURE,
  LOGIN_CODE_DELETE_REQUESTED,
  LOGIN_CODE_DELETE_SUCCESS,
  LOGIN_CODE_DELETE_FAILURE,
} from '../types';

export const loginCodesIndexRequested = () => {
  return {
    type: LOGIN_CODES_INDEX_REQUESTED
  }
}

export const loginCodesIndexSuccess = (loginCodes) => {
  return {
    type: LOGIN_CODES_INDEX_SUCCESS,
    payload: loginCodes
  }
}

export const loginCodesIndexFailure = () => {
  return {
    type: LOGIN_CODES_INDEX_FAILURE
  }
}

export const loginCodeCreateRequested = () => {
  return {
    type: LOGIN_CODE_CREATE_REQUESTED
  }
}

export const loginCodeCreateSuccess = (loginCode) => {
  return {
    type: LOGIN_CODE_CREATE_SUCCESS,
    payload: loginCode
  }
}

export const loginCodeCreateFailure = () => {
  return {
    type: LOGIN_CODE_CREATE_FAILURE
  }
}

export const loginCodeUpdateRequested = (loginCode) => {
  return {
    type: LOGIN_CODE_UPDATE_REQUESTED,
    loginCode: loginCode
  }
}

export const loginCodeUpdateSuccess = (loginCode) => {
  return {
    type: LOGIN_CODE_UPDATE_SUCCESS,
    payload: loginCode
  }
}

export const loginCodeUpdateFailure = () => {
  return {
    type: LOGIN_CODE_UPDATE_FAILURE
  }
}

export const loginCodeDeleteRequested = (loginCode) => {
  return {
    type: LOGIN_CODE_DELETE_REQUESTED,
    loginCode: loginCode
  }
}

export const loginCodeDeleteSuccess = (loginCode) => {
  return {
    type: LOGIN_CODE_DELETE_SUCCESS,
    payload: loginCode
  }
}

export const loginCodeDeleteFailure = () => {
  return {
    type: LOGIN_CODE_DELETE_FAILURE
  }
}

export const loginCodesIndex = () => {
  return async (dispatch) => {
    dispatch(loginCodesIndexRequested());

    const endPoint = Config.baseUrl + Config.loginCodes;
    const headers = await authHeaders();

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(loginCodesIndexSuccess(response.data));
      })
      .catch(() => {
        dispatch(loginCodesIndexFailure());
      });
  }
}

export const loginCodeCreate = (loginCode) => {
  return async (dispatch) => {
    dispatch(loginCodeCreateRequested());

    const endPoint = Config.baseUrl + Config.loginCode;
    const headers = await authHeaders();

    return Axios.post(endPoint, { location_id: loginCode.locationId, duration: loginCode.duration }, { headers: headers })
      .then((response) => {
        dispatch(loginCodeCreateSuccess(response.data));
        // The create response lacks the computed fields the index adds
        // (warehouse_code, qr_code), so reload the list to populate them
        dispatch(loginCodesIndex());
      })
      .catch(() => {
        dispatch(loginCodeCreateFailure());
      });
  }
}

export const loginCodeUpdate = (loginCode) => {
  return async (dispatch) => {
    dispatch(loginCodeUpdateRequested(loginCode.loginCode));

    const endPoint = Config.baseUrl + Config.loginCode;
    const headers = await authHeaders();

    return Axios.put(endPoint, { location_id: loginCode.locationId, id: loginCode.id, duration: loginCode.duration }, { headers: headers })
      .then((response) => {
        dispatch(loginCodeUpdateSuccess(response.data));
      })
      .catch(() => {
        dispatch(loginCodeUpdateFailure());
      });
  }
}

export const loginCodeDelete = (loginCode) => {
  return async (dispatch) => {
    dispatch(loginCodeDeleteRequested(loginCode.loginCode));

    const endPoint = Config.baseUrl + Config.loginCode + loginCode.locationId + '/' + loginCode.id;
    const headers = await authHeaders();

    return Axios.delete(endPoint, { headers: headers })
      .then(() => {
        dispatch(loginCodeDeleteSuccess(loginCode.loginCode));
      })
      .catch(() => {
        dispatch(loginCodeDeleteFailure());
      });
  }
}
